import * as fetch from 'isomorphic-fetch';
import { config } from '../../config/config'
import { handleStatus, setCookie } from '../helper';
var uniqid = require('uniqid');

const accessServiceUrl = `${config.api.base}/access-web`
// const forgetServiceUrl = `${config.api.base}/user/reset-password`
// const resetServiceUrl = (token: string) =>`${config.api.base}/user/${token}`
const authServiceUrl = `${config.api.auth}/auth`
const guestUrl = `${config.api.auth}/auth/via/guest`
const forgetServiceUrl = (email) => `${config.api.auth}/email/${email}`;
const resetServiceUrl = `${config.api.auth}/password`;


export enum UserType {
  GUEST = 0x1,
  USER = 0x3
}

export type UUID = string
export type JWT = string

export interface ITokenResponse {
  token: JWT
}
export interface ForgetRequest {
  email: string
}

export interface IJWTData {
  header: {
    userType: number,
    alg: string
  },
  payload: {
    sub: UUID,
    iss: string,
    iat: number,
    exp: number
  },
  signature: string
}

export function isGuest(permission: number): Boolean {
  return parseInt('0x'+ permission) == UserType.GUEST 
}

export function isUser(permission: number): Boolean {
  return ( parseInt('0x'+ permission) & UserType.USER ) == UserType.USER 
}

class AuthService {
  guestAuthenticate(req, response): Promise<any> {

    const headers = {
      'X-Client-Id': config.webClientID,
      'Content-Type': 'application/json',
      'Client-Model': config.headers.clientModel,
      'Client-Version': config.headers.clientVersion,
      'Device-Model': req.get('User-Agent'),
      'X-Device-Id': req.cookies.payload,
      'REMOTE_ADDR': req.socket.remoteAddress,
      'X-Forwarded-For': req.headers['x-forwarded-for'],
    }
    if (req.cookies.long && req.cookies.lat) {
      headers['userLong'] = req.cookies.long;
      headers['userLat'] = req.cookies.lat;
    }
    !req.cookies[config.cookie.deviceID] && setCookie(req, response, config.cookie.deviceID, uniqid());
    return fetch(guestUrl, {
      method: 'POST',
      headers
    })
      .then(response => handleStatus(response,req) )
    .then(response => response.json())
  }

  verifyJwt(jwt: string): Promise<Response> {
    return fetch(authServiceUrl, {
      method: 'GET',
      headers: {
        'X-Client-Id': config.webClientID,
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${jwt}`
      }
    })
  }

  access(code: string): Promise<Response> {
    return fetch(accessServiceUrl, {
      method: 'POST',
      headers: {
        'X-Client-Id': config.webClientID,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(code)
    })
  }
  forget(req: ForgetRequest): Promise<Response> {
    return fetch(forgetServiceUrl(req), {
      method: 'HEAD',
      headers: {
        'X-Client-Id': config.webClientID,
        'Content-Type': 'application/json'
      },
      // body: JSON.stringify(req)
    })
  }
  reset(req, token: string): Promise<Response> {
    return fetch(resetServiceUrl, {
      method: 'PUT',
      headers: {
        'X-Client-Id': config.webClientID,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(req)
    })
  }
  
}

export const authService = new AuthService()
